(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  define('app/views/pipods/pipod',['marionette', 'templates', 'app/models/Pipod', 'app/views/songs/songItem'], function(Marionette, templates, Pipod, SongItemView) {
    'use strict';
    var PipodView;
    return PipodView = (function(_super) {
      __extends(PipodView, _super);

      function PipodView() {
        return PipodView.__super__.constructor.apply(this, arguments);
      }

      PipodView.prototype.className = 'pipod';

      PipodView.prototype.template = templates.pipods.pipod;

      PipodView.prototype.childView = SongItemView;

      PipodView.prototype.childViewContainer = 'ul';

      PipodView.prototype.childViewEventPrefix = 'song';

      PipodView.prototype.initialize = function(options) {
        this.model = this.pipod = new Pipod({
          mac_address: options.macAddress
        });
        PipodView.__super__.initialize.apply(this, arguments);
        this.pipod.fetch().then((function(_this) {
          return function() {
            return _this.render();
          };
        })(this));
        this.collection = this.nowPlayingList = this.pipod.nowPlayingList;
        this.nowPlayingList.fetch();
        this.updateTimer = setInterval((function(_this) {
          return function() {
            return _this.nowPlayingList.fetch();
          };
        })(this), 15 * 1000);
        return this.listenTo(this, 'song:finished', (function(_this) {
          return function() {
            return _this.nowPlayingList.fetch();
          };
        })(this));
      };

      PipodView.prototype.onBeforeDestroy = function() {
        return clearInterval(this.updateTimer);
      };

      return PipodView;

    })(Marionette.CompositeView);
  });

}).call(this);

//# sourceMappingURL=pipod.js.map
;
